define([
    'common/ui/view/svg/text/area',
    'common/ui/view/svg/text/path',
    'common/ui/view/svg/shape/index',
    'common/ui/view/svg/shape/circle'
], function(
    TextareaView,
    TextpathView,
    Shape,
    CircleShape
    ) {
    var shape = new Shape({});
    var HumanShape = CircleShape.extend({
        tagName: 'g',
        initialize: function(params) {
            params = _.extend({}, params);
            params.r = params.width / 2;
            HumanShape.__super__.initialize.call(this, params);
            this._height = this._width * 2;
        },

        imageSize: function() {
            return this._width;
        },

        imageOffset: function() {
            var imageSize = this.imageSize();
            return {
                x: - imageSize / 2,
                y: - imageSize
            };
        },

        render: function() {
            this.$el.append('circle')
                .attr('r', this._width / 2)
                .attr('cx', 0)
                .attr('cy', - this._height / 4);

            const leftX = - this._width / 2;
            const leftY = this._height / 8;
            const rightX = this._width / 2;
            const rightY = this._height / 8;
            const neckX = 0;
            const neckY = 0;
            const chestX = 0;
            const chestY = this._height / 4;
            const lFootX = - this._width / 2;
            const lFootY = this._height / 2;
            const rFootX = this._width / 2;
            const rFootY = this._height / 2;
            this.$el.append('path')
                .attr('d', `M${leftX},${leftY} L${rightX},${rightY} M${neckX},${neckY} L${chestX},${chestY} M${chestX},${chestY} L${lFootX},${lFootY} M${chestX},${chestY} L${rFootX},${rFootY}`);

            return this;
        },

        createTextArea: function(params) {
            params = _.extend({}, params);
            var strokeOffset = params.strokeOffset || 64;
            var width = this._width - strokeOffset;
            var height = this._height / 2 - strokeOffset;
            var offset = {
                x: - width / 2,
                y: - height / 2 - this._height / 4
            };

            return new TextareaView({
                width: width,
                height: height,
                offset: offset
            });
        },

        createTextpath: function(params) {
            const fromX = - this._width / 2;
            const fromY = - this._height / 4;
            const toX = this._width / 2;
            const toY = - this._height / 4;
            const rx = this._width / 2;
            const ry = this._width / 2;
            const clockwise = 1;

            const path = `M ${fromX},${fromY} A ${rx},${ry} 0 0,${clockwise} ${toX},${toY}`;
            return new TextpathView({
                id: params.id,
                path: path,
                offset: '50%'
            });
        },

        _getEllipsePos: function(angle, offset) {
            offset = offset ? offset : 0;
            var rx = this._r + offset;
            var ry = this._r + offset;
            return {
                x: rx * Math.cos(angle / 180 * Math.PI),
                y: - ry * Math.sin(angle / 180 * Math.PI) - this._height / 4
            };
        }
    }, {
        type: 'human'
    });

    return HumanShape;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/shape/human.js